import { translation } from './en';

const translate = {
  en: {
    translation,
  },
};

export default translate;
